/**
 * Urban Trace — global interactions (Phase 1 foundation)
 * Cart drawer open/close, logo stroke class, mobile nav hooks
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Logo stroke-draw on load
    var logos = document.querySelectorAll('.ut-logo--stroke');
    requestAnimationFrame(function () {
      logos.forEach(function (el) { el.classList.add('is-drawn'); });
    });

    // Cart drawer
    var drawer = document.getElementById('CartDrawer');
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!drawer) return;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Mobile nav
    var nav = document.getElementById('MobileNav');
    var openNav = document.getElementById('NavOpen');
    var closeNav = document.getElementById('NavClose');
    if (openNav && nav) {
      openNav.addEventListener('click', function () {
        nav.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeNav && nav) {
      closeNav.addEventListener('click', function () {
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  });
})();
